const openBtn = document.querySelector('#openModal');
const closeBtn = document.querySelector('#closeModal');
const overlay = document.getElementById('overlay');

function syncPopupBottleColorsFromMain() {
  const selectedMainColorInput = document.querySelector('.color-product-variant input:checked');
  if (!selectedMainColorInput) return;

  const selectedColorValue = selectedMainColorInput.value;
  const escapedValue = window.CSS && CSS.escape ? CSS.escape(selectedColorValue) : selectedColorValue.replace(/"/g, '\\"');

  for (let i = 1; i <= 3; i++) {
    const container = document.querySelector(`.bottle-container .custom-bottle-color-select-${i}`);
    if (!container) continue;

    const radio = container.querySelector(`.color-product-variant-bottle .radio-color-swatch input[value="${escapedValue}"]`);
    if (!radio) continue;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));

    const label = radio.closest('.radio-color-swatch')?.querySelector('label');
    const imgUrl = label?.getAttribute('data-variant-img');
    const productImg = container.querySelector('.product-form__image img');
    if (imgUrl && productImg) {
      productImg.src = imgUrl;
    }
  }
}

if (openBtn) {
  openBtn.addEventListener('click', (e) => {
    e.preventDefault();
    overlay.classList.add('active');
    document.body.classList.add('model-active');
    syncPopupBottleColorsFromMain();
  });
}

if (closeBtn) {
  closeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    overlay.classList.remove('active');
    document.body.classList.remove('model-active');
  });
}

// Optional: close when clicking outside the modal
if (overlay) {
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      e.preventDefault();
      overlay.classList.remove('active');
      document.body.classList.remove('model-active');
    }
  });
}

// on click of swatch, image is changed
for (let i = 1; i <= 3; i++) {
  const container = document.querySelector(`.bottle-container .custom-bottle-color-select-${i}`);
  if (!container) continue;

  const labels = container.querySelectorAll('.color-product-variant-bottle .radio-color-swatch label');

  const productImg = container.querySelector('.product-form__image img');
  if (!productImg) continue;

  labels.forEach((label) => {
    label.addEventListener('click', () => {
      const imgUrl = label.getAttribute('data-variant-img');
      if (!imgUrl) return;

      productImg.src = imgUrl;
    });
  });
}

// cart drawer popup JS start
/*
const cartOpenModal = document.querySelector('#cartopenModal');
const cartOverlay = document.querySelector('#cartOverlay');
const cartClosebtn = document.querySelector('#cartCloseModal');

if (cartOpenModal) {
    cartOpenModal.addEventListener("click", (e) => {
    e.preventDefault();
    cartOverlay.classList.add("active");
    document.body.classList.add("model-active");
  });
}


if (cartClosebtn) {
  cartClosebtn.addEventListener("click", (e) => {
    e.preventDefault();
    overlay.classList.remove("active");
    if (cartOverlay) {
      cartOverlay.classList.remove("active");
    }
    document.body.classList.remove('model-active');
  });
}


if (cartOverlay) {
  cartOverlay.addEventListener("click", (e) => {
    if (e.target === cartOverlay) {
      e.preventDefault();
      cartOverlay.classList.remove("active");
      document.body.classList.remove('model-active');
    }
  });
}

for (let i = 1; i <= 3; i++) {
  const container = document.querySelector(`.bottle-container.cart-drawer-popup .custom-bottle-color-select-${i}`);
  if (!container) continue;

  const labels = container.querySelectorAll('.color-product-variant-bottle .radio-color-swatch label');

  const productImg = container.querySelector('.product-form__image img');
  if (!productImg) continue;

  labels.forEach(label => {
    label.addEventListener('click', () => {
      const imgUrl = label.getAttribute('data-variant-img');
      if (!imgUrl) return;

      productImg.src = imgUrl;
    });
  });
}
*/

// cart drawer popup JS end

document.addEventListener('click', function (e) {
  const cartOverlay = document.getElementById('cartOverlay');
  const body = document.body;

  /* --------------------
     Open cart modal
  -------------------- */
  const openBtn = e.target.closest('#cartopenModal');
  if (openBtn) {
    e.preventDefault();
    if (cartOverlay) {
      cartOverlay.classList.add('active');
      body.classList.add('model-active');
    }
    return;
  }

  /* --------------------
     Close cart modal (button)
  -------------------- */
  const closeBtn = e.target.closest('#cartCloseModal');
  if (closeBtn) {
    e.preventDefault();
    if (cartOverlay) {
      cartOverlay.classList.remove('active');
      body.classList.remove('model-active');
    }
    return;
  }

  /* --------------------
     Close cart modal (overlay click)
  -------------------- */
  if (cartOverlay && e.target === cartOverlay) {
    e.preventDefault();
    cartOverlay.classList.remove('active');
    body.classList.remove('model-active');
    return;
  }

  /* --------------------
     Bottle color swatch click
  -------------------- */
  for (let i = 1; i <= 3; i++) {
    const container = document.querySelector(`.bottle-container.cart-drawer-popup .custom-bottle-color-select-${i}`);
    if (!container) continue;

    const label = e.target.closest(`.custom-bottle-color-select-${i} .color-product-variant-bottle .radio-color-swatch label`);
    if (!label) continue;

    const imgUrl = label.getAttribute('data-variant-img');
    if (!imgUrl) return;

    const productImg = container.querySelector('.product-form__image img');
    if (!productImg) return;

    // Proper radio checked handling
    const radio = label.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Optional active state
    const allLabels = container.querySelectorAll('.color-product-variant-bottle .radio-color-swatch label');
    allLabels.forEach((l) => l.classList.remove('active'));
    label.classList.add('active');

    // Update image
    productImg.src = imgUrl;

    break; // stop loop once matched
  }
});
